import React from 'react';
import HotspotsPlaceholder from './hotspots-table/HotspotsPage';

interface HotspotsViewProps {
  projectId: string;
  handleViewHotspot?: (
    hotspotId: number,
    photoId: number,
    coordinates: { pitch: number; yaw: number }
  ) => void;
}

/**
 * HotspotsView component - manages the hotspots tab content
 *
 * This component serves as a wrapper around HotspotsPlaceholder,
 * providing a consistent interface with other tab views like LayoutsView.
 * It handles the project-specific hotspot data display and management.
 */
const HotspotsView: React.FC<HotspotsViewProps> = ({ projectId, handleViewHotspot }) => {
  return (
    <div className="h-full w-full bg-background/30 overflow-hidden">
      <HotspotsPlaceholder projectId={projectId} onViewHotspot={handleViewHotspot} />
    </div>
  );
};

export default HotspotsView;
